import { render, staticRenderFns } from "./QRCodePage.vue?vue&type=template&id=7f35c7cb&scoped=true&"
import script from "./QRCodePage.vue?vue&type=script&lang=js&"
export * from "./QRCodePage.vue?vue&type=script&lang=js&"
import style0 from "./QRCodePage.vue?vue&type=style&index=0&id=7f35c7cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35c7cb",
  null
  
)

export default component.exports